
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createUpdatePersonaCustomFieldCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UpdatePersonaCustomField extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdatePersonaCustomField';

    public constructor(public id: string, public customFieldId: string, public value: string) {
        super(UpdatePersonaCustomField.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: UpdatePersonaCustomField): Promise<boolean> => {
    return await useSendCommandAsync(action, {
        createCommand: async () => await createUpdatePersonaCustomFieldCommand(action),
    });
};

const reducer = (state: StorymapState, action: UpdatePersonaCustomField): void => {
    const persona = state.personas.find((x) => x.id === action.id);

    const customField = persona.customFields.find(x => x.id == action.customFieldId);
    customField.value = action.value;
};

//@ts-ignore
registerMiddleware(UpdatePersonaCustomField.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdatePersonaCustomField.ACTION_TYPE, reducer);